import { render, staticRenderFns } from "./DetailsConfirmed.vue?vue&type=template&id=7b74b548"
import script from "./DetailsConfirmed.vue?vue&type=script&lang=js"
export * from "./DetailsConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports